export default __webpack_public_path__ + "static/yamlfile-9cae1167cb9dba54fd8eecff6fef0268.png";